import { RootState } from "@/app/store"
import BeatLoader from "react-spinners/BeatLoader"
export default function LoadingSpinner() {
  const loading = useAppSelector((state: RootState) => state.app.loading)
  const [displayLoading, setDisplayLoading] = useState(loading)
  const [to, setTo] = useState<number | null>(null)

  useEffect(() => {
    if (loading === displayLoading) return
    if (loading) {
      if (to !== null) {
        clearTimeout(to)
        setTo(null)
      }
      setDisplayLoading(true)
    } else {
      if (to !== null) {
        clearTimeout(to)
        setTo(null)
      }
      const _to = setTimeout(() => {
        setDisplayLoading(false)
      }, 500)
      setTo(_to)
    }
  }, [loading])

  if (displayLoading) {
    return (
      <div
        className={clsx([
          "bg-white w-screen h-screen fixed inset-0 z-10 flex justify-around items-center transition-all duration-500",
          {
            "opacity-0": !loading,
            "opacity-100": loading,
          },
        ])}
      >
        <BeatLoader color="rgb(255, 149, 0)" />
      </div>
    )
  } else {
    return <div />
  }
}
